import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

ReactDOM.createRoot(document.getElementById("root")).render(<App />);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => navigator.serviceWorker.register("/service-worker.js").catch(() => {}));
}
